import type { OpenClawApp } from "./app.ts";
import { parseSessionKeyPath, type SessionKeyPath } from "./chat/session-key-path.ts";

export function applySessionsScopeLinked(app: OpenClawApp, linked: boolean): void {
  app.applySettings({
    ...app.settings,
    sessionsScopeLinked: linked,
    ...(linked ? { sessionsScopePath: parseSessionKeyPath(app.settings.sessionKey) } : {}),
  });
}

export function applySessionsScopePath(app: OpenClawApp, path: SessionKeyPath): void {
  app.applySettings({
    ...app.settings,
    sessionsScopeLinked: false,
    sessionsScopePath: path,
  });
}

export function applySessionsViewAll(app: OpenClawApp, viewAll: boolean): void {
  app.applySettings({
    ...app.settings,
    sessionsViewAll: viewAll,
    ...(viewAll ? { sessionsScopeLinked: false } : {}),
  });
}
